import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawCanvasIcon from "./RawCanvasIcon.svg.jsx";

const CanvasIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawCanvasIcon} {...props} />;
});

export default CanvasIcon;
